import(/* webpackMode: "eager" */ "/vercel/path0/web-app/src/app/forgot-password/page.tsx");
